/**
 * Get uniba login button action
 * @module src/actions/getUnibaLoginButton
 */
export const GET_UNIBA_LOGINBUTTON = 'GET_UNIBA_LOGINBUTTON';

/**
 * Get uniba login button.
 * @function getUnibaLoginButton
 * @returns {Object} Get uniba login button action.
 */
export function getUnibaLoginButton(params) {
  return {
    type: GET_UNIBA_LOGINBUTTON,
    request: {
      op: 'get',
      path: `/@showLoginButton`,
      params: params,
    },
  };
}
